// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sw-0";
export var checkoutRateBadgeLink = "_sw-1";